import { RefObject, useEffect, useState } from "react";
import useEventListener from "./useEventListener";

const ACTIVE_TIMEOUT = 5000;

const useShowWhenActive = (
  ref: RefObject<HTMLDivElement>,
  precondition: boolean
): void => {
  const [isActive, setIsActive] = useState(true);
  const onEvent = (): void => {
    setIsActive(true);
  };
  useEventListener("mousemove", onEvent);
  useEventListener("touchstart", onEvent);

  useEffect(() => {
    if (isActive && precondition) {
      const timeout = setTimeout(() => {
        setIsActive(!precondition);
        clearTimeout(timeout);
      }, ACTIVE_TIMEOUT);
    }
  }, [isActive, precondition]);

  useEffect(() => {
    if (ref && ref.current) {
      if (isActive) {
        if (precondition) {
          ref.current.style.transition = "all 0.5s";
        } else {
          ref.current.style.transition = "none";
        }
        ref.current.style.opacity = "1";
      } else {
        ref.current.style.transition = "all 0.5s";
        ref.current.style.opacity = "0";
      }
    }
  }, [isActive, ref, precondition]);
};

export default useShowWhenActive;
